import {
  BrowserRouter, Routes, Route 
} from 'react-router-dom';
import {
  QueryClient, QueryClientProvider 
} from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AuthProvider } from './providers/auth-provider';
import { AppLayout } from './components/layout/app-layout';
import { ChatPanel } from './components/ui/chat-panel';
import { DashboardPage } from './pages/dashboard';
import { LoginPage } from './pages/login';
import { SetPasswordPage } from './pages/set-password';
import { ForgotPasswordPage } from './pages/forgot-password';
import { InventoryPage } from './pages/inventory';
import { CatalogPage } from './pages/catalog';
import { RecipesPage } from './pages/recipes';
import { RequisitionsPage } from './pages/requisitions';
import { ProcurementPage } from './pages/procurement';
import { SuppliersPage } from './pages/suppliers';
import { SourcingPage } from './pages/sourcing';
import { WastePage } from './pages/waste';
import { ReceivingPage } from './pages/receiving';
import { GoodsReceivingPage } from './pages/receiving/goods-receiving-page';
import { ProductionPage } from './pages/production';
import { FinancePage } from './pages/finance';
import { ReportsPage } from './pages/reports';
import { MenusPage } from './pages/menus';
import { SettingsPage } from './pages/settings';
import { PerformancePage } from './pages/performance';
import { ProfilePage } from './pages/profile';
import { ProtectedRoute } from './components/auth/protected-route';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider portalType="internal">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Routes>
                      <Route path="/" element={<DashboardPage />} />
                      <Route path="/catalog" element={<CatalogPage />} />
                      <Route path="/catalog/*" element={<CatalogPage />} />
                      <Route path="/recipes" element={<RecipesPage />} />
                      <Route path="/recipes/*" element={<RecipesPage />} />
                      <Route path="/menus" element={<MenusPage />} />
                      <Route path="/menus/*" element={<MenusPage />} />
                      <Route path="/inventory" element={<InventoryPage />} />
                      <Route path="/inventory/*" element={<InventoryPage />} />
                      <Route path="/requisitions" element={<RequisitionsPage />} />
                      <Route path="/requisitions/*" element={<RequisitionsPage />} />
                      <Route path="/production" element={<ProductionPage />} />
                      <Route path="/production/*" element={<ProductionPage />} />
                      <Route path="/receiving" element={<ReceivingPage />} />
                      <Route path="/receiving/goods/:poNumber" element={<GoodsReceivingPage />} />
                      <Route path="/receiving/goods" element={<GoodsReceivingPage />} />
                      <Route path="/receiving/*" element={<ReceivingPage />} />
                      <Route path="/procurement" element={<ProcurementPage />} />
                      <Route path="/procurement/*" element={<ProcurementPage />} />
                      <Route path="/suppliers" element={<SuppliersPage />} />
                      <Route path="/suppliers/*" element={<SuppliersPage />} />
                      <Route path="/sourcing" element={<SourcingPage />} />
                      <Route path="/sourcing/*" element={<SourcingPage />} />
                      <Route path="/finance" element={<FinancePage />} />
                      <Route path="/finance/*" element={<FinancePage />} />
                      <Route path="/waste" element={<WastePage />} />
                      <Route path="/waste/*" element={<WastePage />} />
                      <Route path="/reports" element={<ReportsPage />} />
                      <Route path="/reports/*" element={<ReportsPage />} />
                      <Route path="/performance" element={<PerformancePage />} />
                      <Route path="/performance/*" element={<PerformancePage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="/settings/*" element={<SettingsPage />} />
                      <Route path="/profile" element={<ProfilePage />} />
                    </Routes>
                  </AppLayout>
                  {/* Global AI Chat Assistant */}
                  <ChatPanel />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </QueryClientProvider>
  );
}
